import suppliers, {flightSearchSuppliers} from './suppliers';
import {flighSupplierIds} from './suppliers';

export default function SupplierService() {
    Object.assign(this, {
        isAmadeusId,
        isAmadeusFlightId,
        isBritishAirwaysFlightId,
        isBookingComId,
        isHotelBedsId,
    });

    function isBookingComId(id) {
        return suppliers.bookingCom.id === id;
    }

    function isAmadeusId(id) {
        return suppliers.amadeus.id === id;
    }

    function isHotelBedsId(id) {
        return suppliers.travelcube.id === id;
    }

    function isAmadeusFlightId(id) {
        return flighSupplierIds.AmadeusFlightsId === id;
    }

    function isBritishAirwaysFlightId(id) {
        return flightSearchSuppliers.britishAirways.id === id;
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/supplier/supplier-service.js